/**
 * The deck slots — a deck template's sections.
 *
 * Nothing on a deck is measured off a report: every line takes a count the
 * deck's size works out (deck.ts), so every section is a one-of-each section
 * whose quantity the count replaces. They exist so the Tools editor can show a
 * deck template in the order a deck is built, and so a line names what part of
 * the deck it is.
 */

import type { RoofSlot } from "./roofSlots.js";

const deckSlot = (key: string, label: string): RoofSlot => ({
  key,
  label,
  measurement: null,
  surface: "deck",
});

export const DECK_SLOTS: readonly RoofSlot[] = [
  deckSlot("deck_footings", "Footings and posts"),
  deckSlot("deck_framing", "Framing"),
  deckSlot("deck_decking", "Deck boards"),
  deckSlot("deck_railing", "Railing"),
  deckSlot("deck_stairs", "Steps"),
  deckSlot("deck_labor", "Deck labor"),
];
